import { buildLoginUrl, setAuthenticationState } from './state';

interface ApiOptions extends RequestInit {
    redirectOnUnauthorized?: boolean;
    displayErrorModal?: boolean;
}

// Modal per visualizzare gli errori
let errorModal: HTMLDivElement | null = null;

function showErrorModal(message: string) {
    // Rimuovi modale esistente se presente
    if (errorModal) {
        errorModal.remove();
    }

    // Crea modale
    errorModal = document.createElement('div');
    errorModal.className = 'error-modal-overlay';
    errorModal.innerHTML = `
        <div class="error-modal">
            <div class="error-modal-header">
                <h3>Errore</h3>
                <button class="error-modal-close">&times;</button>
            </div>
            <div class="error-modal-body">
                <p>${message}</p>
            </div>
        </div>
    `;

    document.body.appendChild(errorModal);

    // Chiudi modale al click
    const closeBtn = errorModal.querySelector('.error-modal-close');
    const closeModal = () => {
        if (errorModal) {
            errorModal.remove();
            errorModal = null;
        }
    };

    closeBtn?.addEventListener('click', closeModal);
    errorModal.addEventListener('click', (e) => {
        if (e.target === errorModal) {
            closeModal();
        }
    });
}

export const api = async (url: string, options?: ApiOptions) => {
    const {
        redirectOnUnauthorized = true,
        displayErrorModal = true,
        ...fetchOptions
    } = options ?? {};

    try {
        const response = await fetch(url, {
            credentials: 'include',
            cache: 'no-store',
            headers: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                ...(fetchOptions.headers ?? {}),
            },
            ...fetchOptions,
        });
        
        if (!response.ok) {
            // Se status è 401, reindirizza al login
            if (response.status === 401 && redirectOnUnauthorized) {
                setAuthenticationState(false);
                window.location.href = buildLoginUrl();
                throw new Error('Non autorizzato. Reindirizzamento al login...');
            }
            
            // Prova a estrarre il messaggio di errore dalla risposta
            let errorMessage = `Errore nella richiesta (${response.status})`;
            try {
                const errorData = await response.json();
                if (errorData.error) {
                    errorMessage = errorData.error;
                } else if (errorData.message) {
                    errorMessage = errorData.message;
                }
            } catch {
                // Se non è possibile parsare il JSON, usa il messaggio di default
            }
            
            if (displayErrorModal) {
                showErrorModal(errorMessage);
            }
            throw new Error(errorMessage);
        }
        
        const data = await response.json();
        return data;
    } catch (error) {
        // Se l'errore non è già stato gestito (es. errori di rete)
        if (error instanceof TypeError && error.message.includes('fetch')) {
            const message = 'Errore di connessione. Verifica la tua connessione internet.';
            if (displayErrorModal) {
                showErrorModal(message);
            }
            throw new Error(message);
        }
        // Rilancia l'errore per permettere al chiamante di gestirlo
        throw error;
    }
};
